"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-sixteen/section/testimonialSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider from "react-slick";
import { FC, ComponentProps, Key, ReactNode, useState } from "react";

type HomeSixteenTestimonialSectionTestimonialsItem = {
    /** Detected variants: "assets/img/patients/patient1.jpg" | "assets/img/patients/patient2.jpg" | "assets/img/patients/patient3.jpg" */
    image: string;
    /** Detected variants: "John Doe" | "Sarah Williams" | "Michael Johnson" */
    name: string;
    /** Detected variants: "New York, USA" | "London, UK" | "Sydney, Australia" */
    location: string;
    /** Detected variants: "Exceptional Care and Attention" | "Outstanding Medical Experience" | "Professional and Caring Staff" */
    title: string;
    /** Detected variants: "The doctors here are incredibly knowledgeable and compassionate. I felt well taken care of throughout my entire treatment. Highly recommend this clinic to anyone seeking quality healthcare." | "I had an amazing experience at this clinic. The staff was friendly, the facility was clean, and my doctor took the time to explain everything clearly. I'm very satisfied with the results." | "From the moment I walked in, I knew I was in good hands. The entire team is professional, caring, and dedicated to patient well-being. I couldn't be happier with my experience." */
    description: string;
    /** Detected variants: "quatation" */
    alt?: string;
};

type TestimonialSectionFasFaStarFilledsItem = {
    key: Key | null | undefined;
    /** Detected variants: "fas fa-star filled" */
    className?: string;
};
export type HomeSixteenTestimonialSectionGeneratedProps = {
    testimonials?: HomeSixteenTestimonialSectionTestimonialsItem[];
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Customer Reviews" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "What Our Patients Say" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Reviews" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    sectionDiv0Div1Div0Div0Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    sectionDiv0Div1Div0Div0Slider1SliderProps?: Partial<ComponentProps<typeof Slider>>;
    /** Default: "testimonial" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/reviews/testimonial-img-1.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    testimonialSectionFasFaStarFilleds: TestimonialSectionFasFaStarFilledsItem[];
    testimonialSectionFasFaStarFilledsItemWrapper?: (item: TestimonialSectionFasFaStarFilledsItem, content: ReactNode) => ReactNode;
    testimonialSectionFasFaStarFilledsRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeSixteenTestimonialSectionGenerated: FC<HomeSixteenTestimonialSectionGeneratedProps> = ({
    testimonials = [],
    sectionDiv0Div0Div0DivText = "Customer Reviews",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "What Our Patients Say",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Reviews",
    sectionImageWithBasePath0ImageAlt = "testimonial",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/reviews/testimonial-img-1.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionDiv0Div1Div0Div0Slider0SliderProps,
    sectionDiv0Div1Div0Div0Slider1SliderProps,
    sectionDiv0Div1ClassName,
    testimonialSectionFasFaStarFilleds,
    testimonialSectionFasFaStarFilledsItemWrapper,
    testimonialSectionFasFaStarFilledsRenderer,
}) => {
    const [mainSlider, setMainSlider] = useState<Slider | null>(null);
    const [navSlider, setNavSlider] = useState<Slider | null>(null);
    const navSettings = {
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical: true,
        focusOnSelect: true,
        arrows: false,
        asNavFor: mainSlider ?? undefined,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    vertical: false,
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    vertical: false,
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 580,
                settings: {
                    vertical: false,
                    slidesToShow: 1,
                },
            },
        ],
    };
    const mainSettings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: navSlider ?? undefined,
    };
    return (
        <section className="section testimonial-section-sixteen pt-0">
            <div className="container">
                <div className="section-header-sixteen wow fadeInDown" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <br />
                            <span>{sectionDiv0Div0H20Span0SpanText}</span>
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row justify-content-center"}>
                    <div className="col-lg-10">
                        <div className="slider-wrap vertical-slider testimonial-slider-sixteen">
                            <Slider ref={(slider) => setNavSlider(slider)} {...navSettings} className="slider-nav nav-center testimonial-img-wrap" {...(sectionDiv0Div1Div0Div0Slider0SliderProps ?? {})}>
                                {testimonials.map((item, index) => (
                                    <div key={index} className="slide-item">
                                        <div className="testimonial-user">
                                            <SmartImage
                                                src={item.image}
                                                alt={item.name}
                                                className="img-fluid user-img"
                                            />
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                            <Slider ref={(slider) => setMainSlider(slider)} {...mainSettings} className="slider-for nav-center testimonial-content-wrap" {...(sectionDiv0Div1Div0Div0Slider1SliderProps ?? {})}>
                                {testimonials.map((item, index) => (
                                    <div key={index} className="slide-item">
                                        <div className="testimonial-content">
                                            <div className="rating-star">
                                                <i className="fas fa-star filled"></i>
                                                <i className="fas fa-star filled"></i>
                                                <i className="fas fa-star filled"></i>
                                                <i className="fas fa-star filled"></i>
                                                <i className="fas fa-star filled"></i>
                                            </div>

                                            <div className="testimonial-text">
                                                <h3 className="title">{item.title}</h3>
                                                <p className="description">{item.description}</p>
                                            </div>

                                            <div className="testimonial-author">
                                                <div className="author-info">
                                                    <h4 className="author-name">
                                                        <SmartLink href="#">{item.name}</SmartLink>
                                                    </h4>
                                                    <p className="author-location">{item.location}</p>
                                                </div>

                                                <SmartImage
                                                    src="/Templates/Doccure/img/icons/quatation-icon-2.svg"
                                                    alt={item.alt ?? "quatation"}
                                                    className="img-fluid quatation-icon"
                                                />
                                            </div>

                                            <div className="testimonial-nav-buttons">
                                                <button
                                                    className="testimonial-prev-btn btn"
                                                    onClick={() => mainSlider?.slickPrev()}
                                                >
                                                    <i className="fas fa-arrow-left"></i>
                                                </button>

                                                <button
                                                    className="testimonial-next-btn btn"
                                                    onClick={() => mainSlider?.slickNext()}
                                                >
                                                    <i className="fas fa-arrow-right"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-one" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSixteenTestimonialSectionGenerated;
